import styled from 'styled-components';

import { getVariant } from '@/themes/typographyUtilis';

export const FlatpickrCalendarContainer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  pointer-events: none;

  .flatpickr-calendar {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2) !important;
    border: 1px solid ${({ theme }) => theme.colors.border} !important;
    border-radius: 8px !important;
    background: ${({ theme }) => theme.colors.background.light} !important;
    pointer-events: auto;
  }

  .flatpickr-calendar.hasTime.noCalendar {
    width: 150px !important;
  }

  .flatpickr-calendar.arrowTop {
    margin-top: 5px;
  }

  .flatpickr-calendar.arrowBottom {
    margin-top: -5px;
  }

  .flatpickr-calendar.arrowTop::before {
    border-bottom-color: ${({ theme }) => theme.colors.background.medium} !important;
  }

  .flatpickr-calendar.arrowTop::after {
    border-bottom-color: ${({ theme }) => theme.colors.background.light} !important;
  }

  .flatpickr-months,
  .flatpickr-month,
  .flatpickr-weekdays,
  .flatpickr-weekdaycontainer,
  span.flatpickr-weekday,
  .flatpickr-days,
  .flatpickr-innerContainer,
  .flatpickr-time,
  .flatpickr-monthDropdown-months {
    background: ${({ theme }) => theme.colors.background.light} !important;
  }

  .flatpickr-calendar.hasTime .flatpickr-time {
    border-top: 1px solid ${({ theme }) => theme.colors.background.medium} !important;
  }

  .flatpickr-months {
    border-bottom: 1px solid ${({ theme }) => theme.colors.background.medium} !important;
  }

  .flatpickr-weekdays {
    border-bottom: 1px solid ${({ theme }) => theme.colors.background.medium} !important;
  }

  .flatpickr-month {
    color: ${({ theme }) => theme.colors.primaryText} !important;
    fill: ${({ theme }) => theme.colors.primaryText} !important;
  }

  .flatpickr-prev-month,
  .flatpickr-next-month {
    color: ${({ theme }) => theme.colors.primaryText} !important;
    fill: ${({ theme }) => theme.colors.primaryText} !important;
  }

  .flatpickr-prev-month:hover,
  .flatpickr-next-month:hover {
    color: ${({ theme }) => theme.colors.active} !important;
  }

  .flatpickr-prev-month:hover svg,
  .flatpickr-next-month:hover svg {
    fill: ${({ theme }) => theme.colors.active} !important;
  }

  .flatpickr-current-month,
  .flatpickr-current-month .cur-month,
  .flatpickr-current-month input.cur-year,
  .flatpickr-monthDropdown-months {
    ${getVariant({ variant: 'body1-normal' })};
    margin-right: 12px;
  }

  .flatpickr-current-month .flatpickr-monthDropdown-months,
  span.flatpickr-weekday,
  .flatpickr-day {
    color: ${({ theme }) => theme.colors.primaryText} !important;
  }

  span.flatpickr-weekday,
  .flatpickr-current-month input.cur-year,
  .flatpickr-day {
    ${getVariant({ variant: 'body1-normal' })};
  }

  .flatpickr-day.flatpickr-disabled,
  .flatpickr-day.flatpickr-disabled:hover,
  .flatpickr-day.prevMonthDay,
  .flatpickr-day.nextMonthDay {
    border-color: transparent !important;
    background: transparent !important;
    color: ${({ theme }) => theme.colors.secondaryText} !important;
  }

  .flatpickr-day:hover,
  .flatpickr-day:focus,
  .flatpickr-day.prevMonthDay:hover,
  .flatpickr-day.nextMonthDay:hover {
    border-color: ${({ theme }) => theme.colors.background.medium} !important;
    background: ${({ theme }) => theme.colors.background.medium} !important;
  }

  .flatpickr-day.today {
    border-color: ${({ theme }) => theme.colors.active} !important;
  }

  .flatpickr-day.today:hover,
  .flatpickr-day.today:focus {
    border-color: ${({ theme }) => theme.colors.active} !important;
    background: ${({ theme }) => theme.colors.active} !important;
    color: ${({ theme }) => theme.colors.background.light} !important;
  }

  .flatpickr-day.today.selected {
    box-shadow: none !important;
    border-color: ${({ theme }) => theme.colors.active} !important;
    background: ${({ theme }) => theme.colors.active} !important;
    color: ${({ theme }) => theme.colors.background.light} !important;
  }

  .flatpickr-day.selected,
  .flatpickr-day.selected:hover,
  .flatpickr-day.startRange,
  .flatpickr-day.endRange,
  .flatpickr-day.selected:focus,
  .flatpickr-day.startRange:focus,
  .flatpickr-day.endRange:focus {
    box-shadow: none !important;
    border-color: ${({ theme }) => theme.colors.active} !important;
    background: ${({ theme }) => theme.colors.active} !important;
    color: ${({ theme }) => theme.colors.background.light} !important;
  }

  .flatpickr-day.inRange {
    box-shadow: none !important;
    border-color: ${({ theme }) => theme.colors.background.medium} !important;
    background: ${({ theme }) => theme.colors.background.medium} !important;
  }

  .flatpickr-time input,
  .flatpickr-time .flatpickr-time-separator,
  .flatpickr-time .flatpickr-am-pm {
    color: ${({ theme }) => theme.colors.primaryText} !important;
  }

  .flatpickr-time input:hover,
  .flatpickr-time .flatpickr-am-pm:hover,
  .flatpickr-time input:focus,
  .flatpickr-time .flatpickr-am-pm:focus {
    background: ${({ theme }) => theme.colors.background.medium} !important;
  }

  .flatpickr-time .numInputWrapper {
    background: ${({ theme }) => theme.colors.background.light} !important;
  }

  .flatpickr-time .numInputWrapper span.arrowUp::after {
    border-bottom-color: ${({ theme }) => theme.colors.primaryText} !important;
  }

  .flatpickr-time .numInputWrapper span.arrowDown::after {
    border-top-color: ${({ theme }) => theme.colors.primaryText} !important;
  }

  .numInputWrapper span {
    border-color: ${({ theme }) => theme.colors.background.medium} !important;
  }

  .numInputWrapper span:hover {
    background: ${({ theme }) => theme.colors.background.medium} !important;
  }

  .flatpickr-time .numInputWrapper span:hover {
    background: ${({ theme }) => theme.colors.background.medium} !important;
  }

  .flatpickr-current-month .numInputWrapper span.arrowUp::after {
    border-bottom-color: ${({ theme }) => theme.colors.primaryText} !important;
  }

  .flatpickr-current-month .numInputWrapper span.arrowDown::after {
    border-top-color: ${({ theme }) => theme.colors.primaryText} !important;
  }

  .flatpickr-current-month .flatpickr-monthDropdown-months:hover {
    background: ${({ theme }) => theme.colors.background.medium} !important;
  }
`;

export const FlatpickrInputWrapper = styled.div<{ $withIcon?: boolean }>`
  position: relative;

  input.flatpickr-input,
  input[readonly] {
    width: 100%;
    border: 1px solid
      ${({ theme }) => (theme.theme === 'light' ? theme.colors.border : 'transparent')};
    border-radius: 4px;
    padding: 13px 20px;
    padding-right: ${({ $withIcon }) => ($withIcon ? '40px' : '20px')};
    background: ${({ theme }) => theme.colors.background.light};
    color: ${({ theme }) => theme.colors.primaryText};
    ${getVariant({ variant: 'body1-normal' })};
    text-align: left;
    cursor: pointer;
  }

  input.flatpickr-input::placeholder,
  input[readonly]::placeholder {
    opacity: 0.75;
    color: ${({ theme }) => theme.colors.secondaryText};
  }

  input.flatpickr-input:focus,
  input[readonly]:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.active};
  }
`;

export const FlatpickrInputIcon = styled.span`
  position: absolute;
  top: 50%;
  right: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  color: ${({ theme }) => theme.colors.secondaryText};
  transform: translateY(-50%);
  pointer-events: none;
`;
